import { Translatable } from "@icc/shared/helpers";
import { BaseCoverType } from "./cover";

/** Typ blachy */
export class BlindSheetType extends BaseCoverType {
    id: string | number;
    @Translatable({ model: 'BlindSheetsTypes' })
    name: string;
    description: string;
    type: 'blind_sheet';
    img: string;
    imgSides: string;
    /** Dostępność moskitier */
    mosquitoScreenAvailability: null;
    /** Moskitiera spowoduje niemożliwość stworzenia zestawu wielu żaluzji w jednej skrzynce */
    onlyOneShutterDueMosquitoScreen: false;
    /** Odległość na rynnę górną [mm] */
    spaceToTopRailMM: number;
    /** Kod do indeksów */
    indexNo: string;
    /** Kod do wydruków */
    printCode: string;
    /** Kolejność */
    order: number;

    spaceBundleMm: number;
}